import { useImageReady } from '../../hooks/animations/use-image-ready';
import { ListsIconLarge } from '../../icon/icons-large/lists-large';

export type FilePreviewImageProps = {
  file: File;
};

export const FilePreviewImage = ({ file }) => {
  const imgProps = useImageReady();

  return file.type === 'application/pdf' ? (
    <ListsIconLarge />
  ) : (
    <img {...imgProps} src={URL.createObjectURL(file)} width='auto' height='auto' />
  );
};
